import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["show", "onClose", "width", "height", "title", "detach", "useBackdrop", "showCloseButton", "showMaximizeButton", "onHeightChange", "bodyRef", "bodyClassName", "className", "children"];
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import isFunction from 'lodash/fp/isFunction';
import { getOrCreatePortalRoot } from '../../utils/portalRoot';
var OFFSET_POSITION = -1000;
var BottomSheet = function BottomSheet(props) {
  var show = props.show,
    onClose = props.onClose,
    width = props.width,
    height = props.height,
    title = props.title,
    detach = props.detach,
    useBackdrop = props.useBackdrop,
    showCloseButton = props.showCloseButton,
    showMaximizeButton = props.showMaximizeButton,
    onHeightChange = props.onHeightChange,
    bodyRef = props.bodyRef,
    bodyClassName = props.bodyClassName,
    className = props.className,
    children = props.children,
    remainigProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(show),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMaxHeight = _useState4[0],
    setIsMaxHeight = _useState4[1];
  useEffect(function () {
    return setIsShown(show);
  }, [show]);
  var modalRoot = getOrCreatePortalRoot();
  var handleToggle = function handleToggle() {
    var newValue = !isShown;
    if (isFunction(onClose)) {
      onClose(newValue);
    } else {
      setIsShown(newValue);
    }
  };
  useEffect(function () {
    setIsShown(show);
  }, [show]);
  var handleMaximize = function handleMaximize() {
    var newValue = !isMaxHeight;
    setIsMaxHeight(newValue);
    onHeightChange();
  };
  var sheetClasses = classNames('bottom-sheet', 'position-fixed left-0', !width && 'width-100pct', !height && !isMaxHeight && 'height-auto', 'bg-white', 'shadow-hard', detach ? 'margin-15 rounded' : 'rounded-top-left rounded-top-right', className && className);
  var sheetBodyClasses = classNames('bottom-sheet-body', 'height-100pct', bodyClassName && bodyClassName);
  var sheetHeight = isMaxHeight ? window.innerHeight : height;

  // Note: we always have to kep the body element in the DOM as there might be a ref assigned to it.
  // Unmounting it will lead to loosing the reference and breaking the functionality that is implemented on that ref.
  // That is the reason why there is no "AnimatePresence" with an "exit" animation here.
  // Instead we change the "animate" values.

  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(motion.div, _extends({}, remainigProps, {
    className: sheetClasses,
    width: width,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: isShown ? 1 : 0,
      y: 0,
      bottom: isShown ? 0 : OFFSET_POSITION,
      height: isShown ? sheetHeight : 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "bottom-sheet-header"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: 'bottom-sheet-title display-flex justify-content-between padding-15 ' + 'border border-top-none border-left-none border-right-none border-color-lighter'
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-size-18"
  }, title)), showCloseButton && /*#__PURE__*/React.createElement("div", {
    className: "bottom-sheet-close position-absolute top-10 right-10"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-muted btn-sm btn-icon-only",
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-remove"
  }))), showMaximizeButton && /*#__PURE__*/React.createElement("div", {
    className: 'bottom-sheet-maximize height-30 ' + 'position-absolute top-5 left-50pct translate-x-50 cursor-pointer',
    onClick: handleMaximize
  }, /*#__PURE__*/React.createElement("div", {
    className: "height-5 width-40 rounded bg-lighter"
  }))), /*#__PURE__*/React.createElement("div", {
    className: sheetBodyClasses,
    ref: bodyRef
  }, isShown && children)), useBackdrop && isShown && /*#__PURE__*/React.createElement("div", {
    className: "bottom-sheet-backdrop",
    onClick: handleToggle
  })), modalRoot);
};
BottomSheet.defaultProps = {
  show: false,
  detach: false,
  useBackdrop: false,
  showCloseButton: true,
  showMaximizeButton: false,
  onHeightChange: function onHeightChange() {}
};
BottomSheet.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  showCloseButton: PropTypes.bool,
  showMaximizeButton: PropTypes.bool,
  onHeightChange: PropTypes.func,
  detach: PropTypes.bool,
  useBackdrop: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  bodyRef: PropTypes.object,
  bodyClassName: PropTypes.string,
  className: PropTypes.string
};
export default BottomSheet;